var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sweet-modal",
    { ref: "modal", attrs: { "overlay-theme": "dark" } },
    [
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("loader"),
          _vm._v("\n    " + _vm._s(_vm.$t("message.hero.logging_in")) + "\n  ")
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6658b564", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6658b564","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loader/LoaderModal.vue
// module id = 1453
// module chunks = 0